<template>
  <input class="search-input acclaro-search-input"
         v-model="searchTerm"
         :placeholder="placeholder"/>
</template>

<script>
export default {
  name: "acclaro-input.vue",
  computed: {
      searchTerm: {
        get() { return this.value },
        set(value) {this.$emit('input', value)}
    }
  },
  props: [
    'model',
    'placeholder',
  ],
};
</script>

<style scoped>

.search-input {
  width: 250px;
}
</style>
